module.exports = __webpack_public_path__ + "img/report-viewer-dark.dffdcef5.svg";